/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Video play button: always visible initially, hide when clicked and video plays
  function initVideoPlayButtons() {
    document.querySelectorAll('.video-background').forEach(function(container) {
      var playBtn = container.querySelector('.js-video-play');
      if (!playBtn) return;

      playBtn.addEventListener('click', function() {
        var video = container.querySelector('video');
        if (video) {
          video.play().catch(function() {});
        }
        playBtn.setAttribute('hidden', '');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoPlayButtons);
  } else {
    initVideoPlayButtons();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
